import {CircularProgress, Typography} from "@mui/material"
import {useEffect, useState} from "react"

import FeaturedListing from "../../../components/cards/listings/featuredListing"
import {ResponsiveRow} from "../../../constants/layout.constants"
import {getPersonFavoritesList} from "../../../services/listingsServices/listing.service"
import { isNullUndefined } from "../../../util/util"
import { useNavigate } from "react-router-dom"
import { issueErrorMessage } from "../../../actions/message"

export default function ListingFavourites() {
    const [favListings, setFavListings] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate()
    
    useEffect(() => {
        fetchFavListings()
    }, [])

    function fetchFavListings() {
        setLoading(true)
        getPersonFavoritesList()
            .then((data) => {
                if(!isNullUndefined(data)) {
                    setFavListings(data)
                }
            })
            .finally(() => setLoading(false))
    }

    function viewClicked(item) {
        if (item.statusCd !== "ACT") {
            issueErrorMessage("This listing is no longer available.")
            return
        }
        navigate("/listings/view/" + item.id)
    }

    return (
        <ResponsiveRow
            sx={{flexDirection: "column", width: "100%", alignItems: "center"}}
        >
            <ResponsiveRow
                sx={{
                    width: {xs: "100%", lg: "80%"},
                    padding: "10px auto",
                }}
            >
                <Typography variant="h4" sx={{width: "100%", textAlign: "start"}}>
                    Favorite Listings
                </Typography>
            </ResponsiveRow>
            <ResponsiveRow
                sx={{
                    flexDirection: "row",
                    width: "80%",
                    justifyContent: "center",
                }}
            >
                {loading ? (
                    <ResponsiveRow
                        sx={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            minHeight: "100%",
                        }}
                    >
                        <CircularProgress />
                    </ResponsiveRow>
                ) : favListings && favListings?.length > 0 ? (
                    favListings.map((item, i) => (
                        <FeaturedListing
                            key={i}
                            listing={item}
                            fetchFavListings={fetchFavListings}
                            viewClicked={viewClicked}
                        />
                    ))
                ) : (
                    <ResponsiveRow
                        sx={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            minHeight: "100%",
                            color: "#888"
                        }}
                    >
                        <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#e57373"/>
                        </svg>
                        <Typography variant="h5" sx={{mt: 2, color: "#888"}}>
                            No favorite listings yet!
                        </Typography>
                        <Typography sx={{color: "#aaa"}}>
                            Tap the heart icon on a listing to add it to your favorites.
                        </Typography>
                    </ResponsiveRow>
                )}
            </ResponsiveRow>
        </ResponsiveRow>
    )
}
